import { IAutorizacoes } from './../../../interfaces/token/IAutorizacoes';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ModalGeneralComponent } from 'src/app/components/modal-general/modal-general.component';
import { IInventario } from 'src/app/interfaces';
import { ListaPaginada } from 'src/app/models';
import { InventarioService, AuthenticationService } from 'src/app/services';
import { BotoesFilesComponent } from 'src/app/components/botoes-files/botoes-files.component';
import { FiltroGenericoComponent } from 'src/app/components/filtro-generico/filtro-generico.component';
import { downloadArquivoDeBase64 } from 'src/app/helper';

interface IActiveFilter {
  numeroDeSerie: boolean;
  patrimonio: boolean;
  modelo: boolean;
  site: boolean;
  departamento: boolean;
  emPosseDe: boolean;
  pessoaParaContato: boolean;
}

interface IInputCheckboxEventTarget extends EventTarget {
  checked?: boolean;
}

interface IInputCheckboxEvent extends Event {
  target: IInputCheckboxEventTarget | null;
}

@Component({
  selector: 'app-listagem-inventario',
  templateUrl: './listagem-inventario.component.html',
  styleUrls: ['./listagem-inventario.component.scss']
})
export class ListagemInventarioComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  form: FormGroup;
  numserie: string;
  codSite: string;
  inventarioPDFBase64: string;
  inventarioCSVBase64: string;
  @ViewChild(ModalGeneralComponent) modalSucesso: ModalGeneralComponent;
  @ViewChild(BotoesFilesComponent) botoesDownload: BotoesFilesComponent;
  @ViewChild(FiltroGenericoComponent) filtroGenerico: FiltroGenericoComponent;
  inventarios = new ListaPaginada<IInventario>();
  activeFilter: IActiveFilter = {
    numeroDeSerie: true,
    patrimonio: true,
    modelo: true,
    site: true,
    departamento: true,
    emPosseDe: true,
    pessoaParaContato: true
  };
  token = this.authenticationService.obterToken();
  autorizacoes: IAutorizacoes;
  // Permissoes

  gerenciarPermissoesTela() {
    this.autorizacoes = this.authenticationService.obterToken()['autorizacoes'];
  }

  selectItemsQuantityPerPage: number[] = [5, 10, 15];
  constructor(
    private inventarioService: InventarioService,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService
  ) {}
  handleActiveFilter(
    activeFilterKey: keyof IActiveFilter,
    event: IInputCheckboxEvent
  ) {
    this.activeFilter = {
      ...this.activeFilter,
      [activeFilterKey]: event.target?.checked
    };
  }
  receiveFilterData(filterData: any) {
    this.numserie = filterData?.NumSerie;
    this.codSite = filterData?.CodSite;
  }

  async getInventario(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.inventarios.paginaAtual = 1;
    }

    this.filtroGenerico?.getFilterData();
    this.filtroGenerico?.hidePopUp();

    this.subscriptions$.add(
      this.inventarioService
        .getInventario({
          numserie: this.numserie ?? '',
          codSite: this.codSite ?? '',
          itensPorPagina: this.inventarios.itensPorPagina,
          paginaAtual: this.inventarios.paginaAtual,
          idUsuario: this.token.id
        })
        .subscribe({
          next: ({ data }) => {
            this.inventarios = data;
          }
        })
    );
  }
  fecharModal() {
    this.modalSucesso.closeModal();
  }
  getDownloadPDFInventario() {
    this.subscriptions$.add(
      this.inventarioService
        .getDownloadPDFInventario({
          numserie: this.numserie,
          codSite: this.codSite
        })
        .subscribe({
          next: ({ data }) => {
            this.inventarioPDFBase64 = data;
            downloadArquivoDeBase64({
              base64: data,
              tipo: 'application/pdf'
            });
          }
        })
    );
    this.modalSucesso.openModal();
  }
  getDownloadCSVInventario() {
    this.subscriptions$.add(
      this.inventarioService
        .getDownloadCSVInventario({
          numserie: this.numserie,
          codSite: this.codSite
        })
        .subscribe({
          next: ({ data }) => {
            this.inventarioCSVBase64 = data;
            downloadArquivoDeBase64({
              base64: data,
              tipo: 'text/csv'
            });
          }
        })
    );
    this.modalSucesso.openModal();
  }
  ngOnInit(): void {
    this.form = this.formBuilder.group({
      Numserie: ['']
    });
    this.getInventario();
    this.gerenciarPermissoesTela();
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
